import {
  amazonSellingPartnerSchema,
  FivetranServiceEnum,
} from "@repo/fivetran/types";

import {
  DestinationField,
  DestinationSetupField,
  SchemaField,
} from "./connection-fields";
import { ConnectionFormShell } from "./connection-form-shell";
import {
  type ConnectionFormProps,
  useConnectionForm,
} from "./use-connection-form";

/**
 * Setup form for the Amazon Selling Partner Fivetran connector (Connect Card
 * auth — SP-API app credentials and source settings are collected in the hosted
 * card).
 */
export const AmazonSellingPartnerFormPage = ({
  onConnected,
  onCancel,
}: ConnectionFormProps = {}) => {
  const { form, embedded, formId } = useConnectionForm({
    service: FivetranServiceEnum.enum.amazon_selling_partner,
    schema: amazonSellingPartnerSchema,
    defaultConfig: {
      schema: FivetranServiceEnum.enum.amazon_selling_partner,
    },
    onConnected,
  });

  return (
    <ConnectionFormShell
      form={form}
      formId={formId}
      icon="amazon"
      submitLabel="Authenticate"
      embedded={embedded}
      onCancel={onCancel}
    >
      <DestinationField form={form} />
      <DestinationSetupField form={form} />
      <SchemaField form={form} />
    </ConnectionFormShell>
  );
};
